import {
  ChatAPI,
  appendLocalMessage,
  getCurrentChat,
  setBotTyping,
} from '@guuru/chat-web';
import events from '@guuru/events-web';
import { client } from '@guuru/graphql-web';
import log from '@guuru/logger-web';
import addMessagesNotYetOnAPI from '../../commands/addMessagesNotYetOnAPI';
import createAndTransferChat from '../../commands/createAndTransferChat';
import handleChatGreeting from '../../commands/handleChatGreeting';
import handleRouting from './handleRouting';
import handleShowAnswer from './handleShowAnswer';
import ACCEPT_BOT_ANSWER from './mutations/AcceptBotAnswer';

const addUserPredictResult = (text, options) => {
  const messageStyle = ChatAPI.getMessageStyle();
  const message = ChatAPI.messages.createAnonymousTextMessage(
    text,
    true,
    false,
    {
      isUserPredictionAnswer: true,
      messageStyle,
      response: options?.response,
    },
  );
  ChatAPI.pushPendingMessages(message);
  return message;
};

const actionsToHandle = (channel = 'chat') => {
  const isChat = channel !== 'form';

  return {
    ...(isChat && {
      greeting: handleChatGreeting,
    }),
    routing: handleRouting,
    showAnswer: handleShowAnswer,
  };
};

const acceptBotAnswer = async function ({ partnerId, chatId }) {
  await addMessagesNotYetOnAPI(partnerId, chatId);
  await client.mutate({
    mutation: ACCEPT_BOT_ANSWER,
    variables: { id: chatId },
  });
};

export default {
  // if we don't have an action we don't have a prediction.
  validate(_, { skipAutomation } = {}) {
    const priority = ChatAPI.storeRetrieveChatPriority();
    return !skipAutomation && !priority;
  },

  async render(partnerId, { automationBehavior }) {
    const channel = ChatAPI.storeRetrieveChannel();

    const action = actionsToHandle(channel)[automationBehavior.action];
    if (!action) {
      return { goToNextStep: true };
    }

    events.predict(automationBehavior.label);

    return action(automationBehavior, {
      channel,
      partnerId,
    });
  },

  async processResponse(
    partnerId,
    {
      text,
      response,
      smartFormStyle,
      subscriptionPriority,
      subscriptionTarget,
    },
  ) {
    try {
      const { chatId } = getCurrentChat();
      ChatAPI.storeUserPredictionAnswer(response);
      const channel = ChatAPI.storeRetrieveChannel();
      const automationBehavior =
        ChatAPI.storeRetrieveAutomationBehavior(partnerId);
      const userMessage = addUserPredictResult(text, { channel, response });

      appendLocalMessage(userMessage);

      if (response === 'Yes') {
        setBotTyping(false);
        await acceptBotAnswer({ partnerId, chatId });

        return { stayInCurrentStep: true };
      }

      if (subscriptionPriority === 'transfer' || response === 'Transfer') {
        // In order for the chat to be accepted by the bot we need to make sure
        // that the priority is transfer, as so, we will update the
        // automationBehavior accordingly
        ChatAPI.storeAutomationBehavior(partnerId, {
          ...automationBehavior,
          subscriptionPriority: 'transfer',
        });

        // In this case the user selected that he wanted a transfer
        // as so, it's not a handover (we charge)
        await createAndTransferChat(partnerId, {
          targetId: subscriptionTarget,
        });
        setBotTyping(false);
        return { stayInCurrentStep: true };
      }

      ChatAPI.storeChatPriority(subscriptionPriority);

      if (smartFormStyle) {
        const talkingToExpertMessage = await ChatAPI.addBotMessage(
          'bot:::talkToExpertSmartForm',
        );
        appendLocalMessage(talkingToExpertMessage);
      }
      return {};
    } catch (error) {
      log.error(error);
      return {};
    }
  },
};
